import React, { FC, useState } from 'react';
import { Modal, ModalProps } from '.';
import { Colors } from '../..';
import { Button } from '../buttton';
import { Input } from '../input';
import { ModalConfirmContainer, ModalConfirmBtnContainer } from './styles';

interface FormProps {
    confirmToken: string;
    message: string;
    onConfirm: () => any;
}
interface Props extends ModalProps, FormProps {}
const ModalConfirmTypingForm: FC<FormProps & { onClose: () => any }> = ({
    confirmToken,
    message,
    onConfirm,
    onClose,
}) => {
    const [value, setValue] = useState<string>('');
    return <ModalConfirmContainer>
        <div>
            {message}
        </div>
        <form>
            <Input
                type='text'
                label=""
                name=""
                onChange={(ev) => {
                    setValue(ev.target.value)
                }}
                value={value}
            />
        </form>
        <ModalConfirmBtnContainer>
            <Button
                backgroundColor={Colors.DANGER}
                onClick={onClose}
            >Cancelar</Button>
            <Button
                disabled={value !== confirmToken}
                onClick={onConfirm}
            >Continuar</Button>
        </ModalConfirmBtnContainer>
    </ModalConfirmContainer>
};

const ModalConfirmTyping: FC<Props> = ({
    opened,
    position,
    onClickOutSide,
    width,
    height,
    header,
    confirmToken,
    message,
    onConfirm,
}) => {
    return <Modal
        opened={opened}
        position={position}
        onClickOutSide={onClickOutSide}
        width={width || '400px'}
        height={height}
        header={header}
    >
        <ModalConfirmTypingForm
            confirmToken={confirmToken}
            message={message}
            onConfirm={onConfirm}
            onClose={onClickOutSide}
        />
    </Modal>
}

export { ModalConfirmTyping };
